<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="searchContainer" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<div class="sf-card-column-wrapper">
					<div :style="{ width: '60%' }">
						<user-table ref="userTable" @SelectUser="SelectUser" @refreshUser="refreshUser" :scrId="scrId" />
					</div>
					<div :style="{ width: '38%' }">
						<group-table ref="groupTable" @Refresh="Refresh" :scrId="scrId" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SearchContainer from './Search/SearchContainer.vue';
import UserTable from './Table/UserTable.vue';
import GroupTable from './Table/GroupTable.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchContainer, UserTable, GroupTable },
	methods: {
		Refresh() {
			// console.log('content');
			this.$refs.groupTable.clearTable();
		},
		SelectUser(param) {
			this.$refs.groupTable.getData(param);
		},
		refreshUser(currentPage = 1, pageUnit = 10) {
			this.$refs.searchContainer.searchList(currentPage, pageUnit);
		}
	}
};
</script>

<style scoped>
.sf-card-column-wrapper {
	height: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}
</style>
